import React from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';

const Footer = props => (
  <div className="app-footer">
    <div className="footer-row">
      <Link to="/stores">Locations</Link>
      <div className="link-delimiter">&nbsp;&nbsp; | &nbsp;&nbsp;</div>
      <a href="mailto:support@pepperly.com?Subject=My%20favorite%20store%20is%20not%20on%20Pepperly">Didn't Find a Store? Tell Us More</a>
      <div className="link-delimiter">&nbsp;&nbsp; | &nbsp;&nbsp;</div>
      <a href="mailto:support@pepperly.com?Subject=How%20do%20I%20sell%20on%20Pepperly%3F">Are you a Retailer? Sell at Pepperly</a>
    </div>
    <div className="footer-row">
      <div className="unhighlight"><Link to="/terms-conditions">Terms &amp; Conditions</Link></div>
      <div className="link-delimiter">&nbsp;&nbsp; | &nbsp;&nbsp;</div>
      <div className="unhighlight"><Link to="/privacy-policy">Privacy Policy</Link></div>
      <div className="link-delimiter">&nbsp;&nbsp; | &nbsp;&nbsp;</div>
      <div className="unhighlight">Copyright © 2016-2019 Codextry, Inc., All Rights Reserved</div>
    </div>
    <div className="footer-row">
      <div className="unhighlight">* Same Day Deliveries are made FREE of charge in select areas and for orders over $50</div>
    </div>
  </div>
);

export default Footer



// WEBPACK FOOTER //
// ./src/components/footer/Footer.js